<script>
  import { External, M } from '../../external';
  import Table from '../../Table/Table.svelte';
  import { LmsUtils } from '../utils/LmsUtils';
  import Contact from '../../Contact/Contact.svelte';
  import CommentAdminService from '../../Common/CommentAdminService';
  import { showSettingsPopup } from '../service/LmsUIService';
  import RequestAccessPreview from '../popups/RequestAccessPreview.svelte';
  import { makeLmsRequest } from '../service/LmsClient';

  export let type; // 'paid', 'completed', 'access_requested'
  export let circle;
  export let searchPhrase;

  let loading = false;
  const PAGE_SIZE = 20;
  const commonColumns = [
      {
        key: 'name',
        isNameColumn: true,
        label: External.getById(External.Website.crmProperties, -1)?.label,
        class: 'flex-1 mw-240'
      },
      {
        key: 'email',
        isEmailColumn: true,
        label: External.getById(External.Website.crmProperties, -2)?.label,
        class: 'flex-none'
      }
  ];

  let approveAccessRequest = async (contactId, memberId) => {
    let result = await makeLmsRequest(`/circle/${circle.id}/access-request/${contactId}/${memberId}`, 'POST');
    if (result.ok) {
      discardTableRow(memberId)
    }
  };

  let rejectApproveRequest = async (contactId, memberId) => {
    let result = await makeLmsRequest(`/circle/${circle.id}/access-request/${contactId}/${memberId}`, 'DELETE');
    if (result.ok) {
      discardTableRow(memberId)
    }
  };

  const additionalApproveColumns = [
    {
      type: "icon",
      label: "",
      key: "responses",
      showWhenTruthy: true,
      class: "flex-none mw-140",
      iconClass: "material-icons-outlined circle-effect table-circle-button",
      iconText: "chat",
      onClick: (row, column) => {
        showSettingsPopup({
          width: 420,
          component: (target, close) =>
            new RequestAccessPreview({
              target: target,
              props: {
                settings: circle.settings.requestAccess,
                previewAnswers: row.responses,
                onApprove: () => {
                  approveAccessRequest(row.contactId, row.memberId);
                  close();
                },
                onReject: () => {
                  rejectApproveRequest(row.contactId, row.memberId)
                  close();
                }
              }
            })
        });
      }
    },
    {
      type: "approve_deny",
      label: "",
      class: "flex-none mw-140",
      approve: (row, column) => {
        approveAccessRequest(row.contactId, row.memberId);
      },
      deny: (row, column) => {
        rejectApproveRequest(row.contactId, row.memberId)
      }
    }
  ];

  let activeColumns = [...commonColumns];

  let tableData = {
    loading: false,
    rows: [],
    currentPage: 1,
    total: 0
  };

  const onClick = (row) => {
    External.Tools.showWindow({
      isModal: false,
      withDarkBackground: true,
      width: 840,
      buttons: [],
      noNav: true,
      noTitle: true,
      forceAtRight: true, // window.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, ui) => {
          popup.bindComponent(
            new Contact({
              target: popup.getContentArea(),
              props: {
                id: row.contactId,
                inPopup: true,
                defaultTab: 'lms',
                onComponentReady: () => {}
              }
            })
          );
        }
      }
    });
  };

  const onNextPage = () => {
    load(tableData.currentPage + 1);
  };

  const discardTableRow = (memberId) => {
    tableData.rows = [...tableData.rows.filter(row => row.memberId !== memberId)];
  }

  const load = async (page) => {
    if (loading) {
      return;
    }

    if (tableData.total <= (page - 1) * PAGE_SIZE) {
      return;
    }

    loading = true;
    let result;
    if (type === 'paid') {
      result = await LmsUtils.getPaidCircleMembers(circle.id, searchPhrase, page, PAGE_SIZE);
    } else if (type === 'completed') {
      result = await LmsUtils.getCompletedCircleMembers(circle.id, searchPhrase, page, PAGE_SIZE);
    } else if (type === 'banned') {
      result = await LmsUtils.getBannedCircleMembers(circle.id, searchPhrase, page, PAGE_SIZE);
    } else if (type === 'muted') {
      result = await CommentAdminService.getMutedMembers(circle.id, searchPhrase, page, PAGE_SIZE);
    } else if (type === 'access_requested') {
      result = await LmsUtils.getAccessRequestedMembers(circle.id, searchPhrase, page, PAGE_SIZE);
    } else {
      throw new Error('Not Implemented::' + type);
    }
    if (!result.members) {
      result.members = [];
    }
    tableData.rows = [...tableData.rows, ...result.members];
    tableData.currentPage = result.page;
    tableData.total = result.total;

    loading = false;
  };

  $: {
    // should never be nullish, we're prompting svelte to get reactive by mentioning `type`
    if (type) {
      activeColumns = [...commonColumns];
      if (type === 'access_requested') {
        activeColumns = [...activeColumns, ...additionalApproveColumns];
      }
      tableData.rows = [];
      tableData.total = 0;
      tableData.currentPage = 0;
      load(0);
    }
  }
</script>

<Table
  activeColumns={activeColumns}
  data={tableData.rows}
  {loading}
  {onClick}
  nextPage={onNextPage}
  hasSelection={false}
  hideHeadOnLoad={true}>
  <div class="text-center col20 f-left" style="padding: 70px 30px; box-sizing: border-box;">
    <h3 class="col20 f-left t-center mb-15">{M.NO_MEMBERS_YET}</h3>
  </div>
</Table>
